function showGeneral()
{
  screenType = "general";
  //show("content-title");
  const generalContent = screen_general_text === 'na' ? textScreens[screenType][language][1] : screen_general_text;
  displayText("title", textScreens[screenType][language][0]);
  displayText("content", generalContent);
  showOneButtonStandard(textScreens[screenType][language][2], 560); // empiric value for 1024px screen width
}

function endGeneral()
{
    screen_general="na";
    hide("button1");
    document.getElementById("title").innerHTML = "";
    document.getElementById("content").innerHTML = "";
    main();
}